var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5508 1.90156L8.75001 7.55469V14.7969C8.75001 15.3687 8.10626 15.6965 7.64415 15.3727L5.33556 13.7324C5.11329 13.6016 5.00001 13.3867 5.00001 13.1562V7.55469L0.198058 1.90156C-0.267567 1.33984 0.139933 0.5 0.878136 0.5H12.8703C13.6094 0.5 14.0156 1.33984 13.5508 1.90156Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 0.5H18.75C19.4414 0.5 20 1.13008 20 1.78516C20 2.44023 19.4402 3 18.75 3H17.4648C16.8086 3 16.25 2.36992 16.25 1.71484C16.25 1.05977 16.8086 0.5 17.5 0.5ZM20 8C20 7.30977 19.4414 6.75 18.75 6.75H13.75C13.0586 6.75 12.5 7.30859 12.5 8C12.5 8.69141 13.0598 9.25 13.7148 9.25H18.75C19.4402 9.25 20 8.69023 20 8ZM20 14.25C20 13.5598 19.4414 13 18.75 13H13.75C13.0586 13 12.5 13.5586 12.5 14.25C12.5 14.9414 13.0598 15.5 13.7148 15.5H18.75C19.4402 15.5 20 14.9402 20 14.25Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.9e049d9832d3d78762adf7fef8c60781.svg";
export { ForwardRef as ReactComponent };